module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2018-04-17-test-2/"},"frontmatter":{"title":"Test 2"}}}]}},"pathContext":{"tag":"test"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-test.json
// module id = 339
// module chunks = 267260487189813